<template>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="forms__field_input--message text-sm" v-html="field.content"></div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue';
import type { FieldComponent } from '@src/Common/Components/types';

const props = withDefaults(defineProps<FieldComponent>(), {});

const { field } = toRefs(props);
</script>
